import React, { useState, useContext } from 'react';
import { useNavigate } from "react-router-dom";
import { Alert, Button, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Link } from '@mui/material';
import loginImg from '../assets/undraw_login_re_4vu2.svg';
import url from '../url.js';
import { AuthContext } from '../contexts/AuthContext';
import { getPostLoginRedirect } from '../utils/studentClassRoutes';

export const Login = ({ open, setOpen, setOpenRegister }) => { 
    const navigate = useNavigate();
    const { login } = useContext(AuthContext);
    const [error, setError] = useState('');
    const [data, setData] = useState({
        email: "",
        password: ""
    });

    const handleClose = () => {
        setOpen(false);
        setError('');
    };

    const handleChange = (e) => {
        const value = e.target.value;
        setData({
            ...data,
            [e.target.name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await login(data.email, data.password);
            handleClose();
            navigate(getPostLoginRedirect() || '/main');
        } catch (error) {
            console.error('Login error:', error);
            if (!error.response) {
                setError('網路連線失敗，請確認網路連線後再試');
            } else {
                const msg = error.response?.data?.message || error.response?.data?.error;
                setError(typeof msg === 'string' ? msg : '登入失敗，請檢查您的電子郵件和密碼');
            }
        }
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>登入</DialogTitle>
            <DialogContent>
                <img src={loginImg} alt="Login" style={{ width: '100%', marginBottom: '20px' }} />
                <DialogContentText>
                    請輸入您的電子郵件和密碼
                </DialogContentText>
                {error && (
                    <Alert severity="error" sx={{ mt: 1 }}>
                        {error}
                    </Alert>
                )}
                <TextField
                    autoFocus
                    margin="dense"
                    name="email"
                    label="電子郵件"
                    type="email"
                    fullWidth
                    variant="outlined"
                    value={data.email}
                    onChange={handleChange}
                />
                <TextField
                    margin="dense"
                    name="password"
                    label="密碼"
                    type="password"
                    fullWidth
                    variant="outlined"
                    value={data.password}
                    onChange={handleChange}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>取消</Button>
                <Button onClick={(e) => handleSubmit(e)} variant="contained" color="primary">
                    登入
                </Button>
            </DialogActions>
            <DialogContent>
                <DialogContentText>
                    還沒有帳號？{' '}
                    <Link
                        component="button"
                        variant="body2"
                        onClick={() => {
                            handleClose();
                            setOpenRegister(true);
                        }}
                    >
                        註冊
                    </Link>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
};